import { PopupType } from '../../components/popup/types';
import { crossOriginCommunicationController } from '../../controllers/crossOriginCommunication/CrossOriginCommunicationControllerConnector';
import { OutgoingMessage } from '../../controllers/crossOriginCommunication/types';
import { betActions } from '../../store';
import type { CoreStoreType } from '../../store/CoreStore';
import { popupActions } from '../../store/slices/popup/slice';

import { ConnectionStatus, type IGameCommunicationConnectionObserver } from './types';

export class GameCommunicationConnectionObserver implements IGameCommunicationConnectionObserver {
  update(connectedStatus: ConnectionStatus, store: CoreStoreType): void {
    switch (connectedStatus) {
      case ConnectionStatus.RECONNECTING:
        crossOriginCommunicationController.dispatch(OutgoingMessage.ErrorMessage, {
          errorCode: '8000',
          errorMessage: 'SERVER_CONNECTIVITY_ERROR',
        });
        store.dispatch(popupActions.overwritePopup(PopupType.Reconnecting));
        break;

      case ConnectionStatus.RECONNECTED:
        store.dispatch(popupActions.dismissPopup(PopupType.Reconnecting));
        break;

      case ConnectionStatus.CONNECTION_LOST:
        store.dispatch(popupActions.overwritePopup(PopupType.ConnectionLost));
        break;
      case ConnectionStatus.NEW_ROUND:
        store.dispatch(betActions.setAcceptedBets([]));
        break;
      default:
        break;
    }
  }
}
